import axios from 'axios'
import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Modal,Toast, Container, OverlayTrigger, Tooltip, Form, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { obtenerGrillaHistorial } from '../../../../store/actions/modal-contacto-tercero-action'
import { verDocumento } from '../../../../api/api-modal-contacto-tercero';
import { isValidParam } from '../../../../common/Formatos';
import { descargarArchivo } from '../../../../common/descargarArchivo';
import { LoadingComponent } from 'recupero-comunes'

import { CarpetaDigitalComponent } from 'defcol-caso-general'

const Historial = ({handleCloseContacto, setInstancias, instancias, setIsModoContacto, setIsModoRespuesta, submitLoading}) => {
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false)
  const [listaGrilla, setListaGrilla] = useState(null)
  const [showCarpeta, setShowCarpeta] = useState(false)
  const [idModoIngreso, setIdModoIngreso] = useState('')
  
  const data_modal_contacto = useSelector((state) => state.modalContactoTerceroReducer)
  const { cfg_form15,datosUltimoContacto,comboModoContactoModal, grillaHistorial, modoGlobal} = data_modal_contacto
  
  const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
  const { llaves, datosGestionImplicado } = data_gestion_defensa;

  const handleShowCarpeta = () => setShowCarpeta(true)
   const handleCloseCarpeta= () => setShowCarpeta(false)
  const dispatch = useDispatch()

useEffect(()=>{
  setListaGrilla('')
  //setIsHistorial(false)

},[])
useEffect(()=>{

  setInstancias(
      datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0] && 
        isValidParam(datosGestionImplicado.datosGestionImplicado[0]['instancias']) ? datosGestionImplicado.datosGestionImplicado[0]['instancias'] : ''
  )  
},[datosGestionImplicado])

  useEffect(()=>{
    
     
      setListaGrilla(grillaHistorial && grillaHistorial.grillaHistorial)
   
  },[grillaHistorial])
 const handleHistorial=()=>{
   setIsHistorial(true)
   if (llaves && datosGestionImplicado) {
   
    let query = Buffer.from(JSON.stringify({
        idCaso: llaves && llaves["idCaso"],
        idImplicado: llaves && llaves["idImplicado"],
        idModoIngreso1: 238011,
        idModoIngreso2: 238012,
        tipoGestion: datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion'],
        ambitoGestion: datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion'],
        responsableReasignado: false
    })).toString('base64')
    dispatch(obtenerGrillaHistorial(query))
}
 
 }
 useEffect(()=>{
  idModoIngreso && idModoIngreso!=='' && idModoIngreso===238011 ?console.log("contacto", idModoIngreso):console.log("respuesta", idModoIngreso)
 },[idModoIngreso])

 const handleVerDocumento = async (row) => {
    setLoading(true);
    let query = Buffer.from(JSON.stringify({
        idCaso: llaves.idCaso,
        idImplicadoCaso: llaves.idImplicado,
        idCompania: llaves.idOrgCaso,
        idfolioCarga: row.folioCarga ? row.folioCarga : 240
    })).toString('base64')

    const response = await verDocumento(query);
    descargarArchivo(response);
    setLoading(false);
  }

 const obtenerColumnas = () => {
  return [
    
    
    {
      dataField: 'glosaHito',
      text:cfg_form15? cfg_form15.cfg_form15[
        'contactotercero-grilla-modocto'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'fechaHitoFormat',
      text:cfg_form15?  cfg_form15.cfg_form15[
        'contactotercero-grilla-fechaocurre'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'comentario',
      text:cfg_form15?  cfg_form15.cfg_form15[
        'contactotercero-grilla-comentario'
        
      ]:'',
      
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white',width:'30%' },
     formatter:(cell, row)=>{
      if(cell?.length>30) {
        return <>        
            <a href='#' style={{textDecoration:'none'}} onClick={(e)=>{
              e.preventDefault()
              alert(cell)}}>{cell.substring(0,30)}</a>
              
        </>
       }else{
           return cell
       }
     }
    },
    {
      dataField: 'usuario',
      text:cfg_form15?  cfg_form15.cfg_form15[
        'contactotercero-grilla-usuario'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
    {
      dataField: 'fechaRegistroHitoFormat',
      text:cfg_form15?  cfg_form15.cfg_form15[
        'contactotercero-grilla-fechareg'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
    {
      dataField: 'opciones',
      text: '',
      isDummyField: true,
      headerStyle: (colum, colIndex) => {
        return {
          width: '40%',
          textAlign: 'center',
          verticalAlign: 'center',
          backgroundColor: '#728bb0',
          color: 'white'
        }
      },
      style: { textAlign: 'center', verticalAlign: 'middle' },
      formatter: (cell, row) => (
        
       <div>
          {
          parseInt(row.folioCarga) > 0  ? ( <OverlayTrigger
            overlay={<Tooltip id='tooltip-disabled'>Detalles </Tooltip>}
          >
            <Button
              type='button'
              variant='outline-secondary me-md-2'
              size='sm'
              onClick={() => handleVerDocumento(row)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                        </svg>
            </Button>
          </OverlayTrigger>):null
          
          }
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    }
  ]
}
const handleShow=(row)=>{
  setIdModoIngreso(row.idModoIngreso)
  handleShowCarpeta()
}


  return (
    <>
      <style type='text/css'>
        {`
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    .btn-cambiar {
      background-color:  #286FBF;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-cambiar:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    .btn-recepcionar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-recepcionar:hover{
        background-color: #F6897E;
      color: #FFFFFF;
    }
    .btn-volver {
      
      color: #66CCCC;
      border: 1px solid #C00
     
      width: 140px;

    }
   

    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    `}
      </style>
      <LoadingComponent show={loading} />
      <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">      
        
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
          prototipo={4}  
          folder={idModoIngreso && idModoIngreso!=='' && idModoIngreso===238011 ?'Gest-Contacto-Ter':'Rpta-Contacto-Ter'}            
          />          
      </Modal>
      <Container>
      <Row>
          <Col className='mx-3 mt-2'>
          <Form.Label
                        className='mb-0 mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      > Instancias</Form.Label>
                <br></br>
                <div style={{marginLeft:"20px"}}> 
                    {datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] &&
                      isValidParam(datosUltimoContacto.datosUltimoContacto[0]['instancias']) ? datosUltimoContacto.datosUltimoContacto[0]['instancias'] : '' 
                    }
                </div>
          </Col>
        <Col className='d-flex align-items-end justify-content-end m-2'>
          <Button className='m-2 w-auto' variant='outline-info' onClick={()=>{handleCloseContacto()}}>
            {cfg_form15 && cfg_form15.cfg_form15["contactotercero-btn-cerrar"]}
          </Button>         
          <Button className='m-2' variant='actualizar' type='onSubmit' name='actualizar' disabled={submitLoading}>
            {submitLoading && <Spinner as="span" animation="border" size="sm" className="me-2" />}
            {cfg_form15 && cfg_form15.cfg_form15["contactotercero-btn-actualizar"]}
          </Button>
        </Col>
      </Row>
      <Row className='mt-4 mb-3'>
          <Col>
            <ToolkitProvider
                search
                bootstrap4
                keyField='secuencia'
                data={listaGrilla ? listaGrilla : []}
                columns={obtenerColumnas()}
                defaultSorted={[{ dataField: 'secuencia', order: 'asc' }]}               
                >
                {(props) => (
                    <div>                   
                    <BootstrapTable
                        {...props.baseProps}
                        bordered={false}                          
                        headerWrapperClasses='table-secondary'
                        pagination={paginationFactory({ sizePerPage: 5})}
                        noDataIndication={
                        <div className='text-center'>
                            No hay registros encontrados
                        </div>
                        }
                    />
                    </div>
                )}
            </ToolkitProvider>
          </Col>
      </Row>
      </Container>
    </>
  )
}
export default Historial
